<template>
  <icon-svg-base :view-width="48" :view-height="48" class="icon">
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32"
      :fill="fill"
    >
      <path
        d="m28.882 27.242-3.895-7.07c-.094-.144.045-.231.118-.254.629-.198 1.259-.404 1.537-.906.51-.922-.392-2.438-.153-3.427.246-1.018 1.695-1.896 1.695-2.931 0-1.148-1.495-2.153-1.734-3.146-.238-.99.667-2.504.159-3.427s-2.208-.851-2.906-1.56c-.718-.729-.713-2.512-1.58-3.001-.871-.492-2.289.496-3.256.259-.253-.062-1.866-1.78-2.88-1.78-.999 0-1.854 1.515-2.81 1.746-.968.235-2.384-.755-3.255-.266-.868.488-.866 2.27-1.585 2.998-.699.708-2.398.632-2.908 1.554-.51.922.392 2.438.153 3.427-.245 1.012-1.739 2.19-1.739 3.199 0 1.035 1.445 1.916 1.69 2.934.238.989-.667 2.504-.159 3.427.305.554 1.039.749 1.729.97L3.12 27.187c-.276.499-.053.929.496.954l2.687.123c.549.025 1.237.446 1.529.936l1.43 2.396c.292.489.757.481 1.034-.018l4.009-7.248c.067-.142.157-.074.195-.04.459.412.923.781 1.424.781.511 0 1.123-.392 1.562-.785.039-.035.12-.055.2.044l4.014 7.287c.276.5.741.509 1.034.02l1.434-2.393c.293-.489.982-.909 1.531-.933l2.688-.118c.549-.024.773-.453.497-.953zm-8.073-6.79c-2.724 1.807-6.291 2.002-9.263.184-4.254-2.603-5.702-8.36-3.227-12.834a9.113 9.113 0 0 1 3.339-3.457l.066-.039c4.227-2.421 9.563-.867 11.99 3.539 2.4 4.356 1.086 9.918-2.906 12.607z" />
      <path
        d="M19.812 5.695c-2.412-1.476-5.291-1.375-7.549 0l-.037.022C8.642 7.9 7.416 12.742 9.492 16.511c2.076 3.768 6.68 5.058 10.264 2.875.088-.054.175-.11.26-.167a7.683 7.683 0 0 0 2.511-2.724c2.083-3.765.865-8.609-2.715-10.799zm.776 6.182-1.255 1.286c-.389.398-.632 1.185-.54 1.747l.296 1.816c.092.562-.226.805-.707.54l-1.551-.857c-.48-.266-1.267-.266-1.747 0l-1.551.857c-.48.266-.798.023-.707-.54l.296-1.816c.092-.563-.151-1.349-.54-1.747l-1.255-1.286c-.389-.398-.267-.792.27-.874l1.734-.265c.537-.082 1.173-.568 1.413-1.08l.776-1.652c.24-.512.633-.512.873 0l.775 1.652c.24.512.876.998 1.413 1.08l1.734.265c.537.082.659.475.27.874z" />
    </svg>
  </icon-svg-base>
</template>

<script>
import IconSvgBase from '@/mikan/_shared/components/atoms/icons/IconSvgBase.vue';

export default {
  components: {
    IconSvgBase,
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;

  &__char {
    fill: currentColor;
  }
}
</style>
